import { render, staticRenderFns } from "./dialog-snackbardownload.vue?vue&type=template&id=1d81897b&"
import script from "./dialog-snackbardownload.vue?vue&type=script&lang=js&"
export * from "./dialog-snackbardownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports